module.exports = __webpack_public_path__ + "static/media/userRemove.b008f4eb.svg";